import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./CardCollectionsIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./containers/CardCollectionsList/CardCollectionsList'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () =>
    import('./containers/CardCollectionsFormPage/CardCollectionsFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Content = Loadable({
  loader: () =>
    import('./containers/CardCollectionContent/CardCollectionContent'),
  loading: () => <Loading withContentWrapper />,
});
